// extracted by mini-css-extract-plugin
export default {"colorDrop":"ColorDrop__colorDrop___TxbHA","noColor":"ColorDrop__noColor___XbLyj"};